
/* eslint-disable arrow-parens */
import { defaultClient as apolloClient } from '@/plugins/vue-apollo';
import {
  GET_STATIC_PAGES_GQL,
  GET_STATIC_PAGES_DEFAULT_ROLE_PERMISSIONS_GQL,
} from '@/graphql/static-queries.gql';

export default {
  namespaced: true,

  state: {
    // = data
    staticPages: [],
    staticPagesDefaultRolePermissions: [],
  },

  mutations: {
    SET_STATIC_PAGES(state, payload) {
      state.staticPages = payload;
    },
    SET_STATIC_PAGES_DEFAULT_ROLE_PERMISSIONS(state, payload) {
      state.staticPagesDefaultRolePermissions = payload;
    },
  },

  actions: {
    getStaticPages({ commit }) {
      apolloClient
        .query({ query: GET_STATIC_PAGES_GQL })
        .then(({ data }) => {
          commit('SET_STATIC_PAGES', data.staticPages);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    getStaticPagesDefaultRolePermissions({ commit }) {
      apolloClient
        .query({ query: GET_STATIC_PAGES_DEFAULT_ROLE_PERMISSIONS_GQL })
        .then(({ data }) => {
          commit('SET_STATIC_PAGES_DEFAULT_ROLE_PERMISSIONS', data.staticPagesDefaultRolePermissions);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
  },

  getters: {
    // = computed properties
    staticPages: state => state.staticPages,
    staticPagesDefaultRolePermissions: state => state.staticPagesDefaultRolePermissions,
  },
};
